import { useState } from 'react';
import BreadCrumbs from '@components/Breadcrumbs';
import Button from '@components/Button';
import Alert from '@material-ui/lab/Alert';
import Icon from '@material-ui/core/Icon';
import Form from './Form';
import { apiClient } from '@services/api';
import { format, isValid } from 'date-fns';
import { useHistory } from "react-router-dom";

const Create = (props) => {
  document.title = `Cadastro de combos - ${process.env.REACT_APP_NAME}`
  const history = useHistory();
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [combo, setCombo] = useState({
    from_date: null,
    to_date: null,
    name: null,
    discount: null,
    status: 'Ativo',
    tours: []
  })

  const bradecrumbsConfig = [
    {
      title: 'Início',
      active: true,
      route: '/admin/combos'
    },
    {
      title: 'Novo combo',
    }
  ]

  const changeDate = (date, name) => {
    const value = isValid(date) === true ? format(date, "yyyy-MM-dd") : null
    setCombo({
      ...combo,
      [name]: value
    })
  }

  const changeState = (ev) => {
    setCombo({
      ...combo,
      [ev.target.name]: ev.target.value
    })
  }

  const submitCombos = (ev) => {
    ev.preventDefault();
    apiClient
      .httpInstance.post("/combos", combo)
      .then(response => {
        if (response.status === 200 || response.status === 201) {
          history.push('/admin/combos');
        }
      })
      .catch(error => {
        if (error) {
          setError(true);
          setErrorMessage(error.response.message || "Erro inesperado, tente novamente mais tarde")
          setTimeout(() => { setError(false) }, 4000);
        }
      });
  }

  return <>
    <BreadCrumbs items={bradecrumbsConfig} />
    {error && (
      <Alert className="mb-5" variant="filled" severity="error">
        {errorMessage}
      </Alert>
    )}
    <div className="px-7 pt-6">
      <div className="flex items-center justify-between mt-2 text-2xl text-blue">
        <span>Novo combo</span>
        <Button
          textcolor="#e8f0fb"
          padding="6px 15px"
          width="200"
          variant="outlined"
          onClick={() => history.push('/admin/combos')}
          bgColor="transparent"
        >
          <Icon className="mr-2">
            arrow_back
          </Icon>
          Cancelar
        </Button>
      </div>
      <Form
        {...props}
        isEditing={false}
        combo={combo}
        changeState={changeState}
        changeDate={changeDate}
        submit={submitCombos}
      />
    </div>
  </>
}

export default Create
